import { defineMessages } from 'react-intl';

export default defineMessages({
  contactViaWhatsApp: {
    id: 'app.components.PublisherExperienceTag.contactViaWhatsApp',
    defaultMessage: 'Contact via WhatsApp',
  },
  downloadVCard: {
    id: 'app.components.PublisherExperienceTag.downloadVCard',
    defaultMessage: 'Download contact',
  },
  yearsOld: {
    id: 'app.components.PublisherCard.yearsOld',
    defaultMessage: '{age} years',
  },
});
